<template>
  <DefaultLayout>
    <div class="grid sm:grid-cols-2 grid-cols-1 gap-4 mt-10">
      <div class="bg-white dark:bg-gray-800 rounded-lg p-5 flex w-full justify-between items-center">
        <div class="space-y-1">
          <div class="dark:text-gray-200">الطلاب</div>
          <div class="text-2xl font-meduim dark:text-gray-100">
            {{ students?.length ?? 0 }}
          </div>
        </div>

        <div class="text-2xl font-meduim text-green-500">
          <span class="icon-[ph--users-three] size-10"></span>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg p-5 flex w-full justify-between items-center">
        <div class="space-y-1">
          <div class="dark:text-gray-200">الحلقات</div>
          <div class="text-2xl font-meduim dark:text-gray-100">
            {{ sessions?.length ?? 0 }}
          </div>
        </div>

        <div class="text-2xl font-meduim text-blue-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-10"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z"
            />
          </svg>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <PresenceChart />

      <!-- <div v-if="students">
        <StudentsAgeDistribution :students="students" />
      </div>

      <div v-if="students">
        <StudentsNationalityDistribution :students="students" />
      </div>
      <div v-if="students">
        <StudentsEducationalStageDistribution :students="students" />
      </div>

      <div v-if="students">
        <StudentsEducationTypeDistribution :students="students" />
      </div> -->
    </div>

  </DefaultLayout>
</template>

<script setup lang="ts">
import DefaultLayout from '@/layouts/Default.vue'
import { allSessions } from '@/queries/sessions'
import { allStudents } from '@/queries/students'
import PresenceChart from '@/components/charts/PresenceChart.vue'

const { data: sessions } = allSessions((data) => data, ['name'])
const { data: students } = allStudents(['name'])
</script>

<style scoped></style>
